import { apiRequest } from './_tools';

export function fetchUsers({ page, itemsPerPage, sort, filter }) {
  return apiRequest(`/api/users?page=${page}` +
    `&itemsPerPage=${itemsPerPage}` +
    `&externalId=${filter.externalId}` +
    `&id=${filter.id}` +
    `&locale=${filter.locale}` +
    `&appId=${filter.appId}` +
    `&appName=${filter.appName}` +
    `&platform=${filter.platform}` +
    `&manufacturer=${filter.manufacturer}` +
    `&model=${filter.model}` +
    `&idfa=${filter.idfa}` +
    `&googleAdId=${filter.googleAdId}` +
    `&ip=${filter.ip}` +
    `&country=${filter.country}` +
    `&city=${filter.city}` +
    `&width=${filter.width}` +
    `&height=${filter.height}` +
    `&androidPackageId=${filter.androidPackageId}` +
    `&osVersion=${filter.osVersion}` +
    `&sortKey=${sort.key}` +
    `&order=${sort.order}`)
    .catch(({ error }) => Promise.reject(error));
}

export function fetchUserInterests({ page, itemsPerPage, sort, filter }) {
  return apiRequest(`/api/userInterests?page=${page}&itemsPerPage=${itemsPerPage}` +
    `&_id=${filter._id}` +
    `&externalId=${filter.externalId}` +
    `&country=${filter.country}` +
    `&sortKey=${sort.key}` +
    `&order=${sort.order}`)
    .catch(({ error }) => Promise.reject(error));
}

export function fetchUserInterestDetails({ externalId }) {
  return apiRequest(`/api/userInterestDetails/${externalId}`)
    .catch(({ error }) => Promise.reject(error));
}



/** WEBPACK FOOTER **
 ** ./js/core/api/users.js
 **/